import { FC } from 'react'
import styled from 'styled-components'
import { formatJSONDate } from 'yancey-js-util'

const MetaContainer = styled.div`
  text-align: center;
  width: 100%;
  font-size: 12px;
`

const MetaItem = styled.p`
  display: inline-block;
  margin-right: 20px;
`

interface Props {
  createdAt: string
  lastModified: string
  pv: number
  hidePV?: boolean
}

const Meta: FC<Props> = ({ createdAt, lastModified, pv, hidePV }) => {
  return (
    <MetaContainer>
      <MetaItem>创建时间: {formatJSONDate(createdAt).split(' ')[0]}</MetaItem>
      <MetaItem>
        最后编辑时间: {formatJSONDate(lastModified).split(' ')[0]}
      </MetaItem>
      {hidePV || <MetaItem>点击量: {pv}</MetaItem>}
    </MetaContainer>
  )
}

export default Meta
